export const NewLGA = ({ state, lgas, setNewLga }) => {

  if(state === "Abia") {
    setNewLga(lgas.abia)
  } 
  else if(state === "Adamawa") {
    setNewLga(lgas.adamawa)
  }
  else if(state === "Akwa Ibom") {
    setNewLga(lgas.akwaibom)
  }
  else if(state === "Anambra") {
    setNewLga(lgas.anambra)
  }
  else if(state === "Bauchi") {
    setNewLga(lgas.bauchi)
  }
  else if(state === "Bayelsa") {
    setNewLga(lgas.bayelsa)
  }
  else if(state === "Benue") {
    setNewLga(lgas.benue)
  }
  else if(state === "Borno") {
    setNewLga(lgas.borno)
  }
  else if(state === "Cross River") {
    setNewLga(lgas.crossriver)
  }
  else if(state === "Delta") {
    setNewLga(lgas.delta)
  }
  else if(state === "Ebonyi") {
    setNewLga(lgas.ebonyi)
  }
  else if(state === "Edo") {
    setNewLga(lgas.edo)
  }
  else if(state === "Ekiti") {
    setNewLga(lgas.ekiti)
  }
  else if(state === "Enugu") {
    setNewLga(lgas.enugu)
  }
  else if(state === "Gombe") {
    setNewLga(lgas.gombe)
  }
  else if(state === "Imo") {
    setNewLga(lgas.imo)
  }
  else if(state === "Jigawa") {
    setNewLga(lgas.jigawa)
  }
  else if(state === "Kaduna") {
    setNewLga(lgas.kaduna)
  }
  else if(state === "Kano") {
    setNewLga(lgas.kano)
  }
  else if(state === "Katsina") {
    setNewLga(lgas.katsina)
  }
  else if(state === "Kebbi") {
    setNewLga(lgas.kebbi)
  }
  else if(state === "Kwara") {
    setNewLga(lgas.kwara)
  }
  else if(state === "Lagos") {
    setNewLga(lgas.lagos)
  }
  else if(state === "Nasarawa") {
    setNewLga(lgas.nasarawa)
  }
  else if(state === "Niger") {
    setNewLga(lgas.niger)
  }
  else if(state === "Ogun") {
    setNewLga(lgas.Ogun)
  }
  else if(state === "Ondo") {
    setNewLga(lgas.Ondo)
  }
  else if(state === "Osun") {
    setNewLga(lgas.Osun)
  }
  else if(state === "Oyo") {
    setNewLga(lgas.Oyo)
  }
  else if(state === "Plateau") {
    setNewLga(lgas.Plateau)
  }
  else if(state === "Rivers") {
    setNewLga(lgas.Rivers)
  }
  else if(state === "Sokoto") {
    setNewLga(lgas.Sokoto)
  }
  else if(state === "Taraba") {
    setNewLga(lgas.Taraba)
  }
  else if(state === "Yobe") {
    setNewLga(lgas.Yobe)
  }
  else if(state === "Zamfara") {
    setNewLga(lgas.Zamfara)
  }
  else if(state === "FCT") {
    setNewLga(lgas.FCT)
  }

}